<template>
  <v-card class="mx-auto mt-n3">
    <v-img :src="`${url}${data.banners[0].web}`" class="my-3" contain />
    <v-card-title
      class="justify-center text-uppercase page-title"
      :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
    >
      Chennai Airport
    </v-card-title>
    <v-card-subtitle
      class="text-center"
      :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
    >
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
        Contact us
      </h1>
    </v-card-subtitle>

    <v-container>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="gradi-icon lighten-1" dark> 1 </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="text--primary headingText">
              Airport Director
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Chennai International Airport
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Chennai - 600 027 (TN)
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-row
        class="ml-10 mt-0 mb-5"
        v-scrollanimation
        align="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col cols="12" sm="12" md="4">
          <v-card outlined ronded class="rounded-xl" max-width="344">
            <v-card-text>
              <h3 class="text--primary mb-5 headingText">Phone Number 1 :</h3>
              <div class="text--primary">
                <v-icon color="#00C6FF"> mdi-phone </v-icon>
                <a style="color: #000" href="tel:+91 44 22560551"
                  >+91-44-22560551</a
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-card outlined ronded class="rounded-xl" max-width="344">
            <v-card-text>
              <h3 class="text--primary mb-5 headingText">Phone Number 2 :</h3>
              <div class="text--primary">
                <v-icon color="#00C6FF"> mdi-phone </v-icon>
                <a style="color: #000" href="tel:+91 44 22560512"
                  >+91-44-22560512</a
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-card outlined ronded class="rounded-xl" max-width="344">
            <v-card-text>
              <h3 class="text--primary mb-5 headingText">Email :</h3>
              <div class="text--primary">
                <v-icon color="#00C6FF"> mdi-email </v-icon>
                <a style="color: #000" href="mailto:apdchennai@aai.aero">
                  apdchennai@aai.aero
                </a>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="gradi-icon lighten-1" dark> 2 </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="text--primary headingText">
              Public Grievance Officer
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Chennai International Airport
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Chennai - 600 027 (TN)
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-row
        class="ml-10 mt-5 mb-5"
        v-scrollanimation
        align="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col cols="12" sm="6" md="4">
          <v-card outlined ronded class="rounded-xl" max-width="344">
            <v-card-text>
              <h3 class="text--primary mb-5 headingText">Phone number :</h3>
              <div class="text--primary">
                <v-icon color="#00C6FF"> mdi-phone </v-icon>
                <a style="color: #000" href="tel:+91 044 22564202"
                  >044-22564202</a
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card outlined ronded class="rounded-xl" max-width="344">
            <v-card-text>
              <h3 class="text--primary mb-5 headingText">Email :</h3>
              <div class="text--primary">
                <v-icon color="#00C6FF"> mdi-email </v-icon>
                <a style="color: #000" href="mailto:pgo_chennai@aai.aero">
                  pgo_chennai@aai.aero
                </a>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import config from "../../config";
export default {
  name: "Template-10",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
    };
  },
  methods: {},
  mounted() {},
};
</script>
